import styled from "styled-components";
import { StandardTableSortablePropertyHeader } from "../../../components/tables/StandardTable";
import classNames from "classnames";

const FixedHeader = styled(StandardTableSortablePropertyHeader)`
    ${({ width }) => width ? `width: ${width}%;` : ""}
`;

const NewBusinessRegisterTableHeader = ({ currentSort, sortTable }) => {
    const Header = ({ className, children, ...props }) => <FixedHeader
        {...props}
        sort={currentSort}
        sortTable={sortTable}
        className={classNames(className, "text-truncate")}
    >
        {children}
    </FixedHeader>

    return <thead>
        <tr>
            <Header property={'applicationReferenceId'} width={5}>
                Reference
            </Header>
            <Header property={'masterAccountName'} width={17.5}>
                Client
            </Header>
            <Header property={'adviser'} width={7.5}>
                Adviser
            </Header>
            <Header property={'applicationDate'} width={5}>
                Application
            </Header>
            <Header property={'provider'} width={10}>
                Provider
            </Header>
            <Header property={'description'} width={10}>
                Description
            </Header>
            <Header className="text-end" property={'investmentAmount'} width={5}>
                Investment
            </Header>
            <Header className="text-end" property={'feeAmount'} width={5}>
                Fee
            </Header>
            <Header className="text-end" property={'vatAmount'} width={5}>
                VAT
            </Header>
            <Header className="text-end" property={'netFeeAmount'} width={5}>
                Fee + VAT
            </Header>
            <Header property={'project'} width={10}>
                Project
            </Header>
            <Header property={'report'} width={10}>
                Report
            </Header>
            {/* <Header property={'executionOnly'} width={2.5}>
                Exec. Only?
            </Header> */}
        </tr>
    </thead>
}

export default NewBusinessRegisterTableHeader;